import { Component, OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { BaseComponent } from '../pages/base.component';
import { ToastrService } from "ngx-toastr";
import { CommonService } from "src/app/services/common.service";
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import * as Highcharts from "highcharts/highmaps";
import HC_map from "highcharts/modules/map";

HC_map(Highcharts);
declare var $: any;

@Component({
  selector: 'app-rde-dashboard',
  templateUrl: './rde-dashboard.component.html',
  styleUrls: ['./rde-dashboard.component.css']
})
export class RdeDashboardComponent extends BaseComponent implements OnInit {

  private querySubscription: Subscription = new Subscription();

  @ViewChild("mapContainer", { static: false })
  mapContainer!: ElementRef<HTMLDivElement>;

  countyAndRegionList: any;
  regionGradeList: any;
  selectedRegionId: any;
  schoolLevelId: any;
  selectedCountyId: any;
  regionGeoList: any;
  dashboardDetails: any;
  topCounties: any[] = [];
  educationLevels: any[] = [];
  radius = 50;
  circumference = 2 * Math.PI * this.radius;
  publicDashArray: string = '';
  privateDashArray: string = '';
  privateDashOffset: number = 0;
  countiesList: any[] = [];
  selectedCounty: string = "";
  regionsList: any[] = [];



  constructor(
    protected CommonService: CommonService,
    protected toastr: ToastrService,
    private router: Router,
    private active: ActivatedRoute
  ) {
    super(CommonService, toastr);

  }

  ngOnInit() {

    this.querySubscription = this.active.queryParams.subscribe((res: any) => {
      // Reload data when cd=true or when school level changes (reload flag)
      if (res.cd == 'true' || res.reload === 'true') {
        this.selectedRegionId = localStorage.getItem("region_id");
        this.schoolLevelId = localStorage.getItem("schoolLevelID");
        this.getcountyandRegion();
        this.getRegionGradeList();
        this.getDashboardGeoList();
        this.LoadDBDitails();
      } else {
        this.selectedRegionId = localStorage.getItem("region_id");
        this.schoolLevelId = localStorage.getItem("schoolLevelID");
        this.getcountyandRegion();
        this.getRegionGradeList();
        this.getDashboardGeoList();
        this.LoadDBDitails();
      }
    });


  }



  getcountyandRegion() {
    this.countyAndRegionList = [];
    this.activeSpinner();
    this.CommonService.postCall(`Dashboard/LoadRegionCountiesList`, { "REGION_ID": this.selectedRegionId }).subscribe(
      (res: any) => {
        this.countyAndRegionList = res;
        this.deactivateSpinner();
      },
      (e) => {
        this.deactivateSpinner();
      }
    );
  }
  getRegionGradeList() {
    this.regionGradeList = [];
    this.activeSpinner();
    this.CommonService.postCall(`Dashboard/LoadRegionDashboardGradeList`, { "REGION_ID": this.selectedRegionId, "SCHOOLLEVEL": this.schoolLevelId }).subscribe(
      (res: any) => {
        this.regionGradeList = res;
        this.deactivateSpinner();
      },
      (e) => {
        this.deactivateSpinner();
      }
    );
  }

  getDashboardGeoList() {
    this.regionGeoList = [];
    this.activeSpinner();
    this.CommonService.postCall(`Dashboard/LoadDashboardGeoList`, { "REGION_ID": this.selectedRegionId, "SCHOOLLEVEL": this.schoolLevelId, "COUNTIE_ID": 0 }).subscribe(
      (res: any) => {
        this.regionGeoList = res;
        this.loadMap();
        this.deactivateSpinner();
      },
      (e) => {
        this.deactivateSpinner();
      }
    );
  }


  LoadDBDitails() {
    const userData = JSON.parse(sessionStorage.getItem("userData") || '{}');

    let payLoad = {
      v_tnt_code: localStorage.getItem("TenantCode"),
      v_county_id: userData?.county_id,
      v_sub_county_id: userData?.subcounty_id,
      v_role_id: localStorage.getItem("RoleId"),
      v_schoollevel: localStorage.getItem("schoolLevelID"),
      v_region_id: localStorage.getItem("region_id")
    };

    this.CommonService.postCall(
      `Dashboard/LoadCdeScdeAdminDashboard`,
      payLoad
    ).subscribe((res: any) => {

      this.dashboardDetails = res;

      // Calculate donut chart
      this.calculateDonutChart();

      // TOP COUNTIES DISTRIBUTION
      const counties = res?.TOP_COUNTIES_DISTRIBUTION || [];

      const maxTotal = Math.max(
        ...counties.map((item: any) => item.total),
        0
      );

      this.topCounties = counties.map((item: any) => ({
        ...item,
        percentage: maxTotal > 0
          ? (item.total / maxTotal) * 100
          : 0
      }));

      // EDUCATION LEVEL DISTRIBUTION
      const education = res?.EDUCATION_LEVEL_DISTRIBUTION || [];

      const maxEducation = Math.max(
        ...education.map((item: any) => item.total),
        0
      );

      this.educationLevels = education.map((item: any) => ({
        ...item,
        percentage: maxEducation > 0
          ? (item.total / maxEducation) * 100
          : 0
      }));
    });
  }

  calculateDonutChart() {

    const publicCount =
      Number(this.dashboardDetails?.INSTITUTIONAL_BREAKDOWN?.reject || 0);

    const privateCount =
      Number(this.dashboardDetails?.INSTITUTIONAL_BREAKDOWN?.pending || 0);

    const total = publicCount + privateCount;

    if (!total) {
      this.publicDashArray = `0 ${this.circumference}`;
      this.privateDashArray = `0 ${this.circumference}`;
      this.privateDashOffset = 0;
      return;
    }

    const publicLength =
      (publicCount / total) * this.circumference;

    const privateLength =
      (privateCount / total) * this.circumference;

    this.publicDashArray =
      `${publicLength} ${this.circumference}`;

    this.privateDashArray =
      `${privateLength} ${this.circumference}`;

    this.privateDashOffset = -publicLength;
  }

  // map  development

  async loadMap() {
    if (!this.regionGeoList || this.regionGeoList.length === 0) return;

    let topology;
    if (this.selectedRegionId === "1") {
      topology = await fetch("assets/Maps/Regions/Central.topo.json").then(
        (res) => res.json(),
      );
    }
    if (this.selectedRegionId === "2") {
      topology = await fetch("assets/Maps/Regions/Coast.topo.json").then(
        (res) => res.json(),
      );
    }
    if (this.selectedRegionId === "3") {
      topology = await fetch("assets/Maps/Regions/Eastern.topo.json").then(
        (res) => res.json(),
      );
    }
    if (this.selectedRegionId === "4") {
      topology = await fetch("assets/Maps/Regions/Nairobi.topo.json").then(
        (res) => res.json(),
      );
    }
    if (this.selectedRegionId === "5") {
      topology = await fetch("assets/Maps/Regions/North_Eastern.topo.json").then(
        (res) => res.json(),
      );
    }
    if (this.selectedRegionId === "6") {
      topology = await fetch("assets/Maps/Regions/Nyanza.topo.json").then(
        (res) => res.json(),
      );
    }
    if (this.selectedRegionId === "7") {
      topology = await fetch("assets/Maps/Regions/Rift_Valley.topo.json").then(
        (res) => res.json(),
      );
    }
    if (this.selectedRegionId === "8") {
      topology = await fetch("assets/Maps/Regions/Western.topo.json").then(
        (res) => res.json(),
      );
    }
    const mapFeatures = Highcharts.geojson(topology);

    const mapData = mapFeatures.map((f: any) => {
      const apiCounty = this.regionGeoList.find(
        (c: any) =>
          c.COUNTIES_NAME?.trim().toLowerCase().replace(/\s+/g, "") ===
          f.properties.NAME_1?.trim().toLowerCase(),
      );

      return {
        name: f.properties.NAME_1, // 🔥 join key
        private: apiCounty ? apiCounty.PRIVATE_SCHOOLS : 0,
        value: apiCounty ? apiCounty.PRIVATE_SCHOOLS : 0,
        public: apiCounty ? apiCounty.PUBLIC_SCHOOLS : 0,
        countyId: apiCounty ? apiCounty.COUNTIES_ID : null,
      };
    });

    const maxValue = Math.max(...mapData.map((d) => d.value), 1);

    Highcharts.mapChart(this.mapContainer.nativeElement, {
      chart: { map: topology },
      title: { text: "" },
      credits: { enabled: false },
      mapNavigation: { enabled: true },
      legend: { enabled: false },
      colorAxis: {
        min: 0,
        max: maxValue,
        stops: [
          [0, "#fee2e2"], // very light red
          [0.5, "#fca5a5"], // medium red
          [1, "#b91c1c"], // 🔥 MAX = dark red
        ],
        showInLegend: false,
      },

      series: [
        {
          type: "map",
          data: mapData,

          joinBy: ["NAME_1", "name"], // 🔥 MATCH USING COUNTY NAME

          borderColor: "#000",
          borderWidth: 1,

          states: {
            hover: { brightness: -0.3 },
          },

          dataLabels: {
            enabled: true,
            format: "{point.name}",
            color: "#000",
          },

          tooltip: {
            headerFormat: "",
            pointFormat: "<b>{point.name}</b><br/>Private School: {point.private} <br/>Public School: {point.public}",
          },
          point: {
            events: {
              click: (e: any) => {
                console.log("County:", e.point.name);
                console.log("County ID:", e.point.countyId);
                this.selectedCounty = "";
                this.selectedCountyId = "";
                setTimeout(() => {
                  this.selectedCounty = e.point.name;
                  this.selectedCountyId = e.point.countyId;
                  // this.LoadSubCounties(this.selectedCountyId);
                  // this.LoadChartsData(this.selectedCountyId);
                  // this.LoadTopSubCountysList(this.selectedCountyId);
                }, 200);
              },
            },
          },
        },
      ],
    });
  }

}